import parse from "html-react-parser"
import AnimatedComponent from "../AnimateComponent";
const LandingFeature = ({ data }) => {
    return (
            <div id="features" className="2xl:container mx-auto lg:px-20 pt-20  md:px-14 px-6">
                <div className="flex flex-col gap-16 items-center">
                    <div className="flex flex-col text-center items-center gap-8 md:w-[80%]">
                        <h2 className="md:text-40 text-blue sm:text-32 font-bold">{data.heading}</h2>
                        <p className="text-18 font-regular text-primaryColor">{parse(data.desc)}</p>
                    </div>
                            <AnimatedComponent delay={0.3}>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 relative">
                        {
                            data.list.map((item, index) => (
                                <div key={index} className="feature-hover ">
                                    <div className="flex flex-col gap-8 bg-[#F7F7F7] feature-second items-start p-8 border w-full  border-featureBorder   rounded-[24px]">
                                        <h4 className="text-20 font-semibold text-featureBlack text-left">{item.title}</h4>
                                        <div className="flex flex-col gap-4  overflow-y-hidden feature-list">
                                            {item.content.map((para, ind) => (
                                                <p key={ind} className="text-16 text-left font-regular text-primaryColor flex gap-4 ">
                                                    <img
                                                        src={process.env.PUBLIC_URL + "/images/landing-page/circle-check.svg"}
                                                        alt="icon"
                                                    />
                                                    <span>{para}</span>
                                                </p>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                            </AnimatedComponent>

                </div>
            </div>

    )
}
export default LandingFeature;